// extracted by mini-css-extract-plugin
export default {"page":"D0-z","cartModal":"E0-z","checkout":"F0-z","placeholder":"G0-z","account":"H0-z"};